/**
 * KAN-851: "Назад" в приложении менеджера: на прошлый экран, а если экран
 * открыли сразу по ссылке (истории нет), на вкладку "Внимание".
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { MOBILE_HOME } from '@/lib/mobileApp';

export function useMobileBack(): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    if (window.history.length > 1) navigate(-1);
    else navigate(MOBILE_HOME);
  }, [navigate]);
}
